/**
 * Tenant admin API — her zaman aynı Host üzerinden (admin.{tenant}).
 * Absolute merkezi API (api.codexfix.com) bake edilirse login 404 olur;
 * production/staging’de relative /api/v1 zorlanır.
 */
function resolveApiBase(): string {
  const raw = (import.meta.env.VITE_API_BASE ?? '/api/v1').replace(/\/$/, '') || '/api/v1'
  const isAbsolute = /^https?:\/\//i.test(raw)
  const isLocal =
    /localhost|127\.0\.0\.1/i.test(raw) ||
    (typeof window !== 'undefined' && raw.startsWith(window.location.origin))

  if (isAbsolute && !isLocal) {
    return '/api/v1'
  }

  return raw
}

export const API_BASE = resolveApiBase()
